import { relations } from 'drizzle-orm'
import { jsonb, pgTable, text, timestamp } from 'drizzle-orm/pg-core'
import { coachingClient } from './coaching.js'

export const user = pgTable('User', {
  // Clerk user ID or the exact preseeded server-owned service-principal ID.
  id: text('id').primaryKey(),
  firstName: text('firstName').notNull(),
  lastName: text('lastName').notNull(),
  email: text('email').notNull(),
  company: text('company'),
  settings: jsonb('settings'),
  createdAt: timestamp('createdAt', { mode: 'date' }).defaultNow().notNull(),
  updatedAt: timestamp('updatedAt', { mode: 'date' }).defaultNow().notNull(),
  deletedAt: timestamp('deletedAt', { mode: 'date' }),
})

export const userRelations = relations(user, ({ one }) => ({
  coachingClient: one(coachingClient, {
    fields: [user.id],
    references: [coachingClient.userId],
  }),
}))

export type User = typeof user.$inferSelect
export type NewUser = typeof user.$inferInsert
